// extracted by mini-css-extract-plugin
module.exports = {"c1b0nyni":"c1b0nyni","g1vv9yzt":"g1vv9yzt"};